import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConsentimentoService {
  constructor(private http: HttpClient) {}

  dadosBasicos(client_id: string, scopes: string, tokenJwt: string) {
    const headers = {
      Authorization: tokenJwt,
    };
    return this.http
      .get(
        `${environment.backendUrl}/oauth2/scopes/user/info/${client_id}?scopes=${scopes}`,
        { headers }
      )
      .toPromise();
  }
}
